"use client";

import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import { Section } from "@/types/common";
import { TwoColumnLayout } from "./TwoColumnLayout";
import { Article } from "@/types/article";
import { ReverseColumnLayout } from "./ReverseColumnLayout";
import { FeaturedNewsSection } from "./FeaturedNewsSection";
// import PopupWindow from "./PopupWindow";
import PopupWindowCopy from "./PopupWindow copy 2";
// import { RecentAppointment } from "./RecentAppointment";
// import { SpecialListens } from "../SubCategory/sections/SpecialListens";
// import { UpcomingEventSection } from "../SubCategory/sections/UpcomingEventSection";
// import { OctopusHandpicked } from "../SubCategory/sections/OctopusHandpicked";
// import { PopularVideos } from "../SubCategory/sections/PopularVideos";
// import { OctopusHandpicked } from "../SubCategory/sections/OctopusHandpicked";
// import { RecentProducts } from "./RecentProducts";
// import { RecentAppointment } from "./RecentAppointment";
// import Caraousels from "./Caraousels";
// import { List } from "lucide-react";
// import { CurrentSectionProps } from "@/components/Sections/CurrentSection";

const SpecialListens = dynamic<{ data: Section; showNavigation?: boolean }>(
  () =>
    import("../SubCategory/sections/SpecialListens").then((mod) => ({
      default: mod.SpecialListens,
    })),
  { ssr: false }
);

const Interstitial = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/Interstitial").then((mod) => ({
      default: mod.Interstitial,
    })),
  { ssr: false }
);

const UpcomingEventSection = dynamic<{ data: Section; showNavigation?: boolean }>(
  () =>
    import("../SubCategory/sections/UpcomingEventSection").then((mod) => ({
      default: mod.UpcomingEventSection,
    })),
  { ssr: false }
);

const OctopusHandpicked = dynamic<{ data: Section }>(
  () =>
    import("../SubCategory/sections/OctopusHandpicked").then((mod) => ({
      default: mod.OctopusHandpicked,
    })),
  { ssr: false }
);

const PopularSlider = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/PopularSlider").then((mod) => ({
      default: mod.PopularSlider,
    })),
  { ssr: false }
);

const ThreeColumSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/ThreeColumSection").then((mod) => ({
      default: mod.ThreeColumSection,
    })),
  { ssr: false }
);

const FourColumSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/FourColumSection").then((mod) => ({
      default: mod.FourColumSection,
    })),
  { ssr: false }
);

const EmailSubscription = dynamic<{ data: Section }>(
  () => import("@/components/Newsletter/EmailSubscription"),
  { ssr: false }
);

const HotTopics = dynamic<{ data: Section }>(
  () => import("@/components/Sections/HotTopics").then((mod) => mod.default),
  { ssr: false }
);

const TrendingSectionLeft = dynamic<{ data: Section, hideBrandLogo?: boolean }>(
  () => import("@/components/Sections/TrendingSectionLeft"),
  { ssr: false }
);

// const TrendingSectionLeftLoadMore = dynamic<{ data: Section; hideBrandLogo?: boolean }>(
//   () => import("@/components/Sections/TrendingSectionLeftLoadMore"),
//   { ssr: false }
// );

const RecentAppointment = dynamic<{ data: Section; title: string; showNavigation?: boolean }>(
  () =>
    import("@/components/Sections/RecentAppointment").then(
      (mod) => mod.RecentAppointment
    ),
  { ssr: false }
);

const PopularVideos = dynamic<{ data: Section; title: string; showNavigation?: boolean }>(
  () =>
    import("@/components/Sections/PopularVideos").then(
      (mod) => mod.PopularVideos
    ),
  { ssr: false }
);

const TrendingSectionRight = dynamic<{ data: Section, hideBrandLogo?: boolean }>(
  () => import("@/components/Sections/TrendingSectionRight"),
  { ssr: false }
);

const AdsSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/AdsSection").then((mod) => mod.AdsSection),
  { ssr: false }
);

const VideoCarousel = dynamic<{ data: Section }>(
  () =>
    import("@/components/SubCategory/sections/VideoCarousel").then((mod) => ({
      default: mod.VideoCarousel,
    })),
  { ssr: false }
);

// dynamic<{data: Article[]; title: string}>(
//   () => import("@/components/SubCategory/sections/VideoCarousel").then(mod => ({ default: mod.VideoCarousel })),
//   { ssr: false }
// );

const PremiumContentSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/PremiumContentSection").then((mod) => ({
      default: mod.PremiumContentSection,
    })),
  { ssr: false }
);

const EventsSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/EventsSection").then((mod) => ({
      default: mod.EventsSection,
    })),
  { ssr: false }
);

const BrandInitiativesSection = dynamic<{ data: Section, hideBrandLogo?: boolean }>(
  () =>
    import("@/components/Sections/BrandInitiativesSection").then((mod) => ({
      default: mod.BrandInitiativesSection,
    })),
  { ssr: false }
);

const ResearchSection = dynamic<{ data: Section, hideBrandLogo?: boolean }>(
  () =>
    import("@/components/Sections/ResearchSection").then((mod) => ({
      default: mod.ResearchSection,
    })),
  { ssr: false }
);

const PodcastSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/PodcastSection").then((mod) => ({
      default: mod.PodcastSection,
    })),
  { ssr: false }
);

const HandPickedNewsSection = dynamic<{ data: Section }>(
  () =>
    import("@/components/Sections/HandPickedNewsSection").then((mod) => ({
      default: mod.HandPickedNewsSection,
    })),
  { ssr: false }
);

const RightSection = dynamic<{ data: Section; hideBrandLogo?: boolean }>(
  () =>
    import("@/components/Sections/RightColumn").then((mod) => ({
      default: mod.RightColumn,
    })),
  { ssr: false }
);

const LeftSection = dynamic<{ data: Section; hideBrandLogo?: boolean }>(
  () =>
    import("@/components/Sections/LeftColumn").then((mod) => ({
      default: mod.LeftColumn,
    })),
  { ssr: false }
);
const CurrentSectionDynamic = dynamic<{
  data: Section;
  showLeftBorder?: boolean;
  hideBrandLogo?: boolean;
}>(
  () =>
    import("@/components/Sections/CurrentSection").then((mod) => ({
      default: mod.CurrentSection,
    })),
  { ssr: false }
);
const RecentArticlesSectionDynamic = dynamic<{ articles: Article[] }>(
  () =>
    import("./RecentArticlesSection").then((mod) => ({
      default: mod.RecentArticlesSection,
    })),
  { ssr: false }
);
const ListingSection = dynamic<{ data: Section, hideBrandLogo?: boolean }>(
  () => import("@/components/Sections/ListingSection"),
  { ssr: false }
);

export const SectionRenderer = ({
  sectionsData,
  // showLeftBorder,
  datatemplate,
  showNavigation = true,
  hideBrandLogo,
}: {
  sectionsData: Section[];
  border?: string;
  datatemplate?: string;
  showNavigation?: boolean;
  hideBrandLogo?: boolean;
  // showLeftBorder?: boolean;
}) => {

  return (
    <div className="flex flex-col gap-y-10 lg:gap-y-16 relative w-full">
      {/* <pre className="text-wrap">{JSON.stringify(sectionsData,null,2)}</pre>  */}
      {sectionsData.map((section, index) => (
        <Suspense key={index} fallback={<div className="w-full min-h-[400px] opacity-10 bg-gray-200 animate-pulse rounded-xl"></div>}>
          {(() => {
            switch (section.template) {
              case "popular_event_section":
                return <UpcomingEventSection key={index} data={section} showNavigation={showNavigation} />;
              case "videos_template":
                return (
                  <PopularVideos key={index} data={section} title={""} showNavigation={true} />
                );
              case "hot_topic":
                return <HotTopics key={index} data={section} />;
              case "handpicked_section":
                return <OctopusHandpicked key={index} data={section} />;
              case "special_listens":
                return <SpecialListens key={index} data={section} showNavigation={showNavigation} />;
              case "recent_appointments_section":
                return (
                  <RecentAppointment key={index} data={section} title={""} showNavigation={showNavigation} />
                );
              case "featured_section":
                return <FeaturedNewsSection key={index} data={section} />;
              case "three_column_section":
                return <ThreeColumSection key={index} data={section} />;
              case "four_column_section":
                return <FourColumSection key={index} data={section} />;
              case "ads_section":
                return <AdsSection key={index} data={section} />;
              case "popup_window":
                return <PopupWindowCopy />;
              case "popular-slider":
                return <PopularSlider key={index} data={section} />;
              case "horizontal_long_section":
                return <VideoCarousel key={index} data={section} />;
              case "premium_section":
                return <PremiumContentSection key={index} data={section} />;
              case "trending_section_right":
                return <TrendingSectionRight key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "trending_section_left":
                return <TrendingSectionLeft key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "trending_section_left_load_more":
                return (
                  // <TrendingSectionLeftLoadMore key={index} data={section} hideBrandLogo={hideBrandLogo} />
                  <ListingSection key={index} data={section} hideBrandLogo={hideBrandLogo} />
                );
              case "events_section":
                return <EventsSection key={index} data={section} />;
              case "brand_section":
                return <BrandInitiativesSection key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "research_section":
                return <ResearchSection key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "podcast_section":
                return <PodcastSection key={index} data={section} />;
              case "handpicked_section":
                return <HandPickedNewsSection key={index} data={section} />;
              case "two_column_layout":
                return <TwoColumnLayout key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "right_section":
                return <RightSection key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "newsletter_section":
                return <EmailSubscription key={index} data={section} />;
              case "left_section":
                return <LeftSection key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "current_section":
                return (
                  <CurrentSectionDynamic
                    key={index}
                    data={section}
                    showLeftBorder={datatemplate == "right_section" ? true : false}
                    hideBrandLogo={hideBrandLogo}
                  />
                );
              case "recent_articles":
                return (
                  <RecentArticlesSectionDynamic
                    key={index}
                    articles={section.articles || []}
                  />
                );
              case "reverse_column_layout":
                return <ReverseColumnLayout key={index} data={section} hideBrandLogo={hideBrandLogo} />;
              case "listing_section":
                return <ListingSection key={index} data={section} />;
              case "interstitial":
                return <Interstitial key={index} data={section} />;
              default:
                return (
                  <>
                    {section.template} is Missing
                    <br />
                  </>
                );
            }
          })()}
        </Suspense>
      ))}
    </div>
  );
};
